export const getParamByName = key => {
  var matches = location.hash.match(new RegExp(key+'=([^&]*)'))
  return matches ? matches[1] : null
}

/** updates URL params
* @param {Object} data // new params
*/
export const updateUrlHash = data => {
  // odstrani hash ze zacatku
  var search = location.hash.substring(1);
  // vytvori s paramteru objekt
  let params = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
  function(key, value) { return key===""?value:decodeURIComponent(value) }) : {}

  // change params
  for(let newParam in data) {
    params[newParam] = data[newParam]
  }

  let newHash = ''
  for(let param in params) {
    if(params[param] !== '')
      newHash += `${param}=${params[param]}&`
  }

  // updatuje URL hash a odstrani posledni "&"
  // replaceState updateuje hash, ale neprida zaznam do historie
  window.history.replaceState( {} , 'foo', `#${newHash.slice(0, -1)}`)
}

/** prida dalsi parametr do URL hash
* @param {Object} data Prijma hodnoty, ktere se pote pridaji do URL
*/
export let addNewParams = data => {
  // remove hash from start
  let search = location.hash.substring(1)

  // vytvori s paramteru objekt
  let params = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
  function(key, value) { return key===""?value:decodeURIComponent(value) }) : {}

  // add params
  for(let newParam in data) {
    params[newParam] = data[newParam]
  }

  let newHash = ''
  for(let param in params) {
    if(params[param] !== '')
      newHash += `${param}=${params[param]}&`
  }

  // updates URL hash and remove last "&"
  // replaceState updates hash but do not add record to history
  window.history.replaceState( {} , 'foo', `#${newHash.slice(0, -1)}`)
}

export const removeParam = (sourceURL, key) => {
  let rtn = sourceURL.split("#")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("#") !== -1) ? sourceURL.split("#")[1] : ""
  if (queryString !== "") {
      params_arr = queryString.split("&")
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1)
          }
      }
      rtn = params_arr.join("&")
  }

  // replaceState updates hash but do not add record to history
  window.history.replaceState( {} , 'foo', `#${rtn}`)
}



// WEBPACK FOOTER //
// ./app/utils/urlParamsControllers.js